import { render, staticRenderFns } from "./SearchFacetType.vue?vue&type=template&id=07236758"
import script from "./SearchFacetType.vue?vue&type=script&lang=js"
export * from "./SearchFacetType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports